import React from 'react'
import { CommonCalendarButtonUi } from 'common/components/entities/Calendar/calendar-step/ui/common-calendar-button-ui'
import { PaidCalendarPaymentButtonProps } from 'common/types/entities/booking-paid-calendar-interface'
import FieldErrors from 'publisher/components/FieldErrors'
import useStripeIdealPaymentHandler from 'publisher/hooks/payment/useStripeIdealPaymentHandler'
import useManagement, {
  selectors as managementSelectors,
} from 'publisher/hooks/useManagement'
import { useStripeGeneralPaymentHandler } from 'publisher/hooks/payment/use-stripe-general-payment-handler'

export const PaidCalendarStripeGeneralPaymentButton = ({
  entity,
  commonStyles,
}: PaidCalendarPaymentButtonProps) => {
  const { errors, isLoading, handleSubmit } =
    useStripeGeneralPaymentHandler(entity)
  const isPreview = useManagement(managementSelectors.isPreviewMode)
  return (
    <React.Fragment>
      <CommonCalendarButtonUi
        backgroundColor={entity.selectedSlotBackgroundColor}
        onClick={handleSubmit}
        disabled={isLoading || isPreview}
        {...commonStyles}
      >
        {entity.formButtonText}
      </CommonCalendarButtonUi>
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}
